// Permission strings mirror internal/auth/permissions.go.
//
// The portal asks "may I?" rather than "what am I?", exactly as the API does.
// Navigation, buttons and routes are all driven by the capability list returned
// from /v1/me, so a role added on the server appears here without a release and
// the interface can never offer something the API will refuse.
export const P = {
  quote: "shipment.quote",
  book: "shipment.book",
  viewShipments: "shipment.view",
  cancelShipment: "shipment.cancel",
  editShipment: "shipment.edit",

  viewAddresses: "address.view",
  manageAddresses: "address.manage",

  viewBilling: "billing.view",
  manageBilling: "billing.manage",

  viewUsers: "user.view",
  manageUsers: "user.manage",
  manageApiKey: "apikey.manage",
  viewSettings: "account.settings.view",
  editSettings: "account.settings.edit",

  opsDashboard: "ops.dashboard",
  opsShipments: "ops.shipments",
  opsFleet: "ops.fleet",
  opsHub: "ops.hub",
  opsSupport: "ops.support",
  opsAccounts: "ops.accounts",

  platformDashboard: "platform.dashboard",
  platformAccounts: "platform.accounts",
  platformUsers: "platform.users",
  platformRoles: "platform.roles",
  impersonate: "platform.impersonate",
  platformBilling: "platform.billing",
  platformSecrets: "platform.secrets",
  platformSettings: "platform.settings",

  driverApp: "driver.app",
} as const;

export type Permission = (typeof P)[keyof typeof P];

export const roleLabels: Record<string, string> = {
  owner: "Account owner",
  admin: "Account admin",
  operator: "Account user",
  shipment_editor: "Shipment editor",
  viewer: "View only",
  viewer_no_billing: "View only, no billing",
  guest: "Guest",
  driver: "Driver",
  ops_manager: "Operations manager",
  client_care: "Client care",
  platform_admin: "Platform admin",
  super_admin: "Super admin",
};
